module.exports = __webpack_public_path__ + "img/省人工智能理事但闻.7dce6160.jpg";